import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import MainFont from 'ui/typography/mainFont';

import Button from '../Button';
import {
  CardText,
  CardTextGray,
  CardTextWrapper,
  CardWrapper,
  IconElement
} from './style';

const AccountCard = ({
  img,
  title,
  email,
  role,
  handleChangePassword,
  password,
  date,
  corporate,
  firstTitle,
  firstContent,
  secondContent,
  secondTitle,
  changeSitesButton,
  handleChangeSites,
  thirdTitle,
  thirdContent,
  handleEditPersonalData
}) => {
  const { t } = useTranslation();

  const loadContent = content => {
    if (Array.isArray(content)) {
      return content.map((cont, i) => (
        <MainFont configuration={{ fontSize: 16, fontWeight: 600 }} key={i}>
          <CardText>{cont}</CardText>
        </MainFont>
      ));
    }
    return (
      <MainFont configuration={{ fontSize: 16, fontWeight: 600 }}>
        <CardText>{content}</CardText>
      </MainFont>
    );
  };

  return (
    <CardWrapper>
      <IconElement img={img} />
      <CardTextWrapper>
        {' '}
        {firstTitle && (
          <MainFont configuration={{ fontSize: 16 }}>
            <CardTextGray>{firstTitle}</CardTextGray>
          </MainFont>
        )}
        {firstContent && loadContent(firstContent)}
        {secondTitle && (
          <MainFont configuration={{ fontSize: 16 }}>
            <CardTextGray>{secondTitle}</CardTextGray>
          </MainFont>
        )}
        {secondContent && loadContent(secondContent)}
        {handleChangePassword && (
          <Button variant="changepassword" onClick={handleChangePassword}>
            {t('change_password')}
          </Button>
        )}
        {thirdTitle && (
          <MainFont configuration={{ fontSize: 16 }}>
            <CardTextGray>{thirdTitle}</CardTextGray>
          </MainFont>
        )}
        {thirdContent && loadContent(thirdContent)}
        {handleEditPersonalData && (
          <Button variant="changepassword" onClick={handleEditPersonalData}>
            {t('edit')}
          </Button>
        )}
      </CardTextWrapper>
    </CardWrapper>
  );
};

AccountCard.propTypes = {
  img: PropTypes.string,
  title: PropTypes.string,
  email: PropTypes.string,
  role: PropTypes.string,
  handleChangePassword: PropTypes.func,
  password: PropTypes.string,
  date: PropTypes.string,
  firstTitle: PropTypes.string,
  firstContent: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  secondContent: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  secondTitle: PropTypes.string,
  thirdTitle: PropTypes.string,
  thirdContent: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  changeSitesButton: PropTypes.bool,
  handleChangeSites: PropTypes.func,
  handleEditPersonalData: PropTypes.func
};

export default AccountCard;
